import { useEffect, useState } from "react";
import { Grid } from '@mui/material';
import { useNavigate } from "react-router-dom";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { useSpecificAttributeStore } from "../../hooks/useSpecificAttributeStore";
import { SpecificUseModal } from "./components/SpecificUseModal";
import { useSpecificUseStore } from "../../hooks/useSpecificUseStore";

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'code', label: 'Código', align:'center' },
    { type: 'text', field: 'name', label: 'Nombre', align:'center' },
    { type: 'detail', field: 'detail', label: 'Detalle', align:'center' },
];

export const SpecificUsesView = () => {

    const navigate = useNavigate();
    // const { search } = useSelector(selectHeaderState);

    const { setActionSpecificUse, getSpecificUses, getSpecificUsesByCompany, deleteSpecificUse } = useSpecificUseStore();

    const [loading, setLoading] = useState(false);
    const [uses, setUses] = useState<any>([]);
    const [rowSelected, setRowSelected] = useState<any>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);

    useEffect(() => {
        getSpecificUsesApi()
    },[])

    const getSpecificUsesApi = async(search='') => {
        try {
            setLoading(true);
            const response = await getSpecificUsesByCompany(search);
            if(!response){
                setUses([]);
                setLoading(false);
                return false;
            }else{
                setUses(response || []);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onAdd = () => {
        setActionSpecificUse('add');
        setShowModal(true);
    }
    const onEdit = (rowSelected:any) => {
        setActionSpecificUse('edit');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const onDelete = (rowSelected:any) => {
        setActionSpecificUse('delete');
        setRowSelected(rowSelected);
        setShowModalConfirm(true);
    }
    const onDetails = (rowSelected:any) => {
        setActionSpecificUse('detail');
        setRowSelected(rowSelected);
        setShowModal(true);
    }

    const onDeleteConfirm = async() => {
        if (rowSelected) {
            setLoading(true);
            const response = await deleteSpecificUse(rowSelected.id)
            if(response){
                getSpecificUsesApi();
                setShowModalConfirm(false);
                setLoading(false);
                setRowSelected('');
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getSpecificUsesApi(term)}, 1000)
        )
    }

    const clearState = () => {
        setRowSelected('');
    }

    return (
        <>
            <Grid item xs={12}>
                <CustomTable 
                    title={'Usos específicos del producto'}
                    columns={columns} 
                    loading={loading}
                    rows={uses || []}
                    onRowClick={() => {}}
                    hasOptions
                    onAddFn={onAdd}
                    onAddFnName={'Nuevo uso específico'}
                    onDetails={onDetails}
                    onDelete={onDelete}
                    onEdit={onEdit}
                    onSearch={onSearch}
                    dense
                />
            </Grid>
            {
                showModal && (
                    <SpecificUseModal
                        open = {showModal}
                        closeModal = {() => {setShowModal(false)}}
                        attributeSelected = {rowSelected}
                        listAttributeUse = {getSpecificUsesApi}
                        clearState = {clearState}
                    />
                )
            }
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={()=>{ setShowModalConfirm(false); clearState()}}
                        onConfirm={onDeleteConfirm}
                        status={loading}
                    />
                )
            }
        </>
    )
}